var map = {
	"./stamp_00.jpg": "gbzI",
	"./stamp_01.jpg": "9MxQ",
	"./stamp_02.jpg": "qqIV",
	"./stamp_03.jpg": "vrlf",
	"./stamp_04.jpg": "WeAW",
	"./stamp_05.jpg": "FcUZ",
	"./stamp_06.jpg": "MPJo",
	"./stamp_07.jpg": "NrE8",
	"./stamp_08.jpg": "q/GI",
	"./stamp_09.jpg": "KQOL",
	"./stamp_10.jpg": "1Aqb",
	"./stamp_11.jpg": "3zfs",
	"./stamp_12.jpg": "Kfnd",
	"./stamp_13.jpg": "NitU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Fp/x";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing ^\.\/stamp_.*\.jpg$
// module id = Fp/x
// module chunks = 1